export const maxLengthDescription = 2000;
export const minCharacterLength = 3;
export const minAreaCharacterLength = 10;
export const maxCharacterLength = 255;
export const maxBioRatio = 100;
export const maxHours = 8760;
export const maxFirstYear = 2055;
export const minFirstYear = new Date().getFullYear();
export const specialChars = '[^;\'"]+';
export const anlagenbeschreibungSpecialChars = String.raw`^[A-Za-zÄÖÜäöüß0-9 .,:!?'()\-_'\/@&%$€+=#|\x22]*$`;
export const charsAllowedFromBE = "/^[A-Za-zÄÖÜäöüß0-9 .,:!?'()\\-_'/@&%$€+=#|\"\x22]+$/";

